module.exports = __webpack_public_path__ + "img/maisonette-1.c0cc4301.webp";